var _rect, _rect2, _g, _g2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 300,
    viewBox: "0 0 132.29 79.375",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.765,
    y: 4.7624,
    width: 23.683,
    height: 3.7042,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#b7b7e1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.218 -.19168)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.212,
    y: 2.0242,
    width: 48.179,
    height: 75.71,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.34414
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "submit",
    transform: "matrix(1.3007 0 0 1.3007 -2.2456 -3.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.817,
    y: 54.894,
    width: 19.012,
    height: 5.5571,
    rx: 0.40684,
    ry: 0.40684,
    fill: "#b9b2e6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "upload-i",
    transform: "matrix(.0075316 0 0 .0075316 46.985 55.622)",
    fill: "#392781"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m798.01 421.41-169.74-169.69c-15.625-15.625-40.969-15.625-56.555 0l-169.73 169.69 56.605 56.555 101.41-101.4v423.43h79.992v-423.43l101.45 101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880 720v160.01h-559.99v-160.01h-80.004v160.01c0 43.98 36.012 79.992 80.004 79.992h559.99c43.992 0 80.004-36.012 80.004-79.992v-160.01z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 51.575,
    width: 13.229,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#392781"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.52,
    y: 55.35,
    width: 43.735,
    height: 9.3218,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#392781",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.723,
    y: 45.902,
    width: 18.521,
    height: 2.9104,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#f00"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.505,
    y: 45.355,
    width: 3.8452,
    height: 3.8452,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#f00",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 41.704,
    width: 31.75,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#f00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 34.712,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ffa900",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 31.810261,
    y: 38.079994,
    fill: "#ffa900",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeMiterlimit: 10,
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----"), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 31.242,
    width: 15.875,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffa900"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 24.388,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#00f",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 20.78,
    width: 11.906,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#0200ff"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b7b7e1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 16.306,
    width: 31.66,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 13.209,
    width: 44.049,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 10.111,
    width: 44.049,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.66445 0 0 .66445 5.2083 10.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.4425,
    y: 21.22,
    width: 107.9,
    height: 44.598,
    rx: 1.5928,
    ry: 1.5928,
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.4425 29.157h107.76",
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -3.2969,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#0100ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 31.274,
    width: 19.844,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#6766ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 31.274,
    width: 21.167,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ffcb66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 31.274,
    width: 22.49,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#33f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#f33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#4c4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 48.712,
    width: 21.167,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#0200ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ffd480"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 54.525,
    width: 17.198,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#4d4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 60.338,
    width: 19.844,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 31.274,
    width: 19.981,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#8976d5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 37.087,
    width: 19.937,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#452f9d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 42.899,
    width: 16.778,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#7862d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 48.712,
    width: 21.985,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 54.525,
    width: 19.547,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#9b8adb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 60.338,
    width: 17.574,
    height: 3.9688,
    rx: 2.9865,
    ry: 2.9865,
    fill: "#7862d0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeDasharray: "1.19062, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.662 59.819h-19.945v-3.5274",
    stroke: "#392781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.662 44.996h-5.5419l-0.39822 25.218h-32.147l-0.12039-13.923",
    stroke: "#f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.662 34.353h-5.4882v-17.023h-50.202v6.405",
    stroke: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.645 19.242v-14.48l-80.156-0.22709v19.2",
    stroke: "#00f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormLinked);
export default __webpack_public_path__ + "static/media/form-linked.21bbba479f4f32b7df592026eb3ccc2f.svg";
export { ForwardRef as ReactComponent };